import { EdgeListHuntPackagesRepository } from '@/shared/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { ListHuntPackages } from '@/shared/domain'

export function makeListHuntPackages(): ListHuntPackages {
  return new EdgeListHuntPackagesRepository(makeSupabaseEdgeHttpClient()).execute
}
